import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const tabs = [
  {
    id: 'embedding',
    name: 'Instant Embedding',
    title: 'Instant Embedding',
    description: 'Easily integrate your content and data in seconds. Our instant embedding feature allows you to connect resources seamlessly, making your workflow faster and more efficient without any technical hassle.',
    image: '/images/integration/embedding.png',
  },
  {
    id: 'branding',
    name: 'Custom Branding',
    title: 'Custom Branding',
    description: "Tailor CLEONA's look and personality so every response feels like your own. Customize colors, add your logo, and set the tone to match your brand identity perfectly.",
    image: '/images/integration/analytics.png',
  },
  {
    id: 'conversations',
    name: 'Real-Time Conversations',
    title: 'Real-Time Conversations',
    description: 'Fast, natural chat with responses that feel human. Your users get instant answers while CLEONA handles multiple conversations simultaneously.',
    image: '/images/integration/conversations.png',
  },
  {
    id: 'analytics',
    name: 'Analytics and Insights',
    title: 'Analytics and Insights',
    description: 'Track engagement, see top questions, and close knowledge gaps. Understand what your users need most and continuously improve your assistant.',
    image: '/images/integration/branding.png',
  },
  {
    id: 'security',
    name: 'Enterprise Security',
    title: 'Enterprise Security',
    description: 'Built with privacy first. SOC 2 ready with encryption, access controls, and compliance safeguards. Your data stays secure and protected.',
    image: '/images/integration/enterprise-security.png',
  }
];

export default function IntegrationSection() {
  const [activeTab, setActiveTab] = useState('embedding');

  const activeTabData = tabs.find(tab => tab.id === activeTab);

  return (
    <section className="py-24 bg-cleona-50/30">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Section header */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between mb-12">
          <div>
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="text-cleona-600 font-manrope font-semibold text-sm">Everything You Want</span>
              <span className="flex items-center justify-center w-6 h-6 rounded-full bg-cleona-600">
                <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                </svg>
              </span>
            </div>
            <h2 className="font-jakarta text-4xl font-bold text-gray-900 sm:text-5xl">
              Instant Integration
            </h2>
          </div>
          <p className="mt-6 lg:mt-0 max-w-md text-gray-600 font-manrope lg:text-right">
            Professional-grade features to create, scale, and manage your Smart Assistant™.
          </p>
        </div>

        {/* Tabs */}
        <div className="mb-8 overflow-x-auto">
          <div className="flex gap-2 min-w-max border-b border-gray-200">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-3 font-manrope font-semibold text-sm transition-colors whitespace-nowrap border-b-2 -mb-px ${
                  activeTab === tab.id
                    ? 'border-cleona-600 text-gray-900'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                {tab.name}
              </button>
            ))}
          </div>
        </div>

        {/* Tab content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Text content */}
          <div>
            <h3 className="font-jakarta text-3xl font-bold text-gray-900 mb-4">
              {activeTabData.title}
            </h3>
            <p className="text-gray-600 font-manrope text-lg leading-relaxed mb-8">
              {activeTabData.description}
            </p>
            <Link
              to="/admin/signup"
              className="inline-flex items-center gap-2 rounded-pill bg-cleona-600 px-6 py-3 text-base font-semibold text-white hover:bg-cleona-700 transition-colors font-manrope"
            >
              Learn More
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>

          {/* Right - Illustration */}
          <div className="relative bg-gradient-to-br from-gray-50 to-cleona-50 rounded-2xl p-8 flex items-center justify-center">
            <img
              src={activeTabData.image}
              alt={activeTabData.title}
              className="w-full max-w-md h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
